module.exports = "/images/cookie_consent_hero.svg?0ae62965abb9faa0b8f044846e4bba15";